import React, { Suspense, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";
import Navbar from "./Components/Navbar";
import InstagramRedirect from "./Utils/InstagramModal";
import PrivateRoute from "./Utils/PrivateRoute";
import { setLanguage, getLanguageFromQuery } from "./Redux/languageActions";
// VyaktigatArjee will be lazy loaded below
// Firebase will be dynamically imported inside useEffect
import GlobalLoader from "./Components/GlobalLoader";
import OfferingSkeleton from "./Components/Common/OfferingSkeleton";
import ArjeeActiveSkeleton from "./Components/Common/ArjeeActiveSkeleton";

const Home = React.lazy(() => import("./Components/HomePage/Home"));
const TermsAndConditions = React.lazy(() => import("./Components/Policy"));
const LoginPage = React.lazy(() => import("./Components/Login/Login"));
const Dashboard = React.lazy(() => import("./Components/Dashboard/Dashboard"));
const ArjeeVideo = React.lazy(
  () => import("./Components/ArjeeVideo/ArjeeVideo"),
);
const DainikArjeeVideo = React.lazy(
  () => import("./Components/ArjeeVideo/DainikArjeeVideo"),
);
const VyaktigatArjeeVideo = React.lazy(
  () => import("./Components/ArjeeVideo/VyaktigatArjeeVideo"),
);
const VyaktigatArjee = React.lazy(
  () => import("./Components/ArjeePages/VyaktigatArjee/VyaktigatArjee"),
);
const EkadashiArjee = React.lazy(
  () => import("./Components/ArjeePages/VyaktigatArjee/EkadashiArjee"),
);
const VyaktigatArjeeFirstPage = React.lazy(
  () =>
    import("./Components/ArjeePages/VyaktigatArjee/VyaktigatArjeeFirstPage"),
);
// const Description = React.lazy(
//   () => import("./Components/CreatorProgram/Description"),
// );
// const CreatorLogin = React.lazy(
//   () => import("./Components/CreatorProgram/Login"),
// );
// const CreatorDashboard = React.lazy(
//   () => import("./Components/CreatorProgram/Dashboard"),
// );
// const Details = React.lazy(() => import("./Components/CreatorProgram/Details"));
const Bheed = React.lazy(() => import("./Components/BheedBhad/BheedBhad"));
const BheedDetails = React.lazy(
  () => import("./Components/BheedBhad/BheedDetails"),
);
const SwayamArjee = React.lazy(
  () => import("./Components/ArjeePages/SwayamArjee/SwayamArjee"),
);
const SwayamArjeeLanding = React.lazy(
  () => import("./Components/ArjeePages/SwayamArjee/SwayamArjeeLanding"),
);
const SwayamArjeeFirstPage = React.lazy(
  () => import("./Components/ArjeePages/SwayamArjee/SwayamArjeeFirstPage"),
);
const DainikArjeeFirstPage = React.lazy(
  () => import("./Components/ArjeePages/DainikArjee/DainikArjeeFirstPage"),
);
const DainikArjee = React.lazy(
  () => import("./Components/ArjeePages/DainikArjee/DainikArjee"),
);
const MahaBhogFirstPage = React.lazy(
  () => import("./Components/MahaBhog/MahaBhogFirstPage"),
);
const LandingPage = React.lazy(
  () => import("./Components/ParamStays/LandingPage"),
);
const HotelBookingPage = React.lazy(
  () => import("./Components/ParamStays/HotelBookingPage"),
);
const MyReview = React.lazy(() => import("./Components/Reviews/MyReview"));
const AllReview = React.lazy(() => import("./Components/Reviews/AllReview"));
const ParkingStreets = React.lazy(() => import("./Components/ParkingStreets"));
const ArjeeLanding = React.lazy(
  () => import("./Components/ArjeeLanding/ArjeeLanding"),
);
const ArjeeChoose = React.lazy(
  () => import("./Components/ArjeeLanding/ArjeeChoose"),
);
const BlogPost = React.lazy(() => import("./Components/Blog/BlogPost"));
const BlogList = React.lazy(() => import("./Components/Blog/BlogList"));

const BhogArjeePage = React.lazy(
  () => import("./Components/BhogArjee/BhogArjeePage"),
);
const BhogArjeeCart = React.lazy(
  () => import("./Components/BhogArjee/BhogArjeeCart"),
);

// const MelaUpdates = React.lazy(
// () => import("./Components/LakhiMela/MelaUpdates"),
// );
// const MelaParkings = React.lazy(
// () => import("./Components/LakhiMela/MelaParkings"),
// );
// const MelaRoutes = React.lazy(
// () => import("./Components/LakhiMela/MelaRoutes"),
// );
const MapRoutes = React.lazy(() =>
  import("./Components/MapRoutes").then((m) => ({ default: m.MapRoutes })),
);

const WhatIsOnlineSeva = React.lazy(
  () => import("./Components/InfoPages/WhatIsOnlineSeva"),
);

const SwayamCreatorLogin = React.lazy(
  () => import("./Components/SwayamCreator/SwayamCreatorLogin"),
);
const SwayamCreatorDashboard = React.lazy(
  () => import("./Components/SwayamCreator/SwayamCreatorDashboard"),
);

const NotFoundFallback = () => <Navigate to="/" replace />;
const BheedRedirect = () => <Navigate to="/bheed-bhad" replace />;

const routesConfig = [
  { path: "/what-is-online-temple-seva", element: WhatIsOnlineSeva },
  { path: "/", element: Home },
  { path: "/login", element: LoginPage },
  { path: "/policy", element: TermsAndConditions },
  // { path: "/cart", element: Cart },
  { path: "/arjee-video", element: ArjeeVideo },
  { path: "/arjee-video-da", element: DainikArjeeVideo },
  { path: "/arjee-video-va", element: VyaktigatArjeeVideo, private: true },
  { path: "/dainik-arjee-first", element: DainikArjeeFirstPage },
  { path: "/dainik-arjee", element: DainikArjee },
  { path: "/swayam-arjee", element: SwayamArjee },
  { path: "/swayam-arjee-landing", element: SwayamArjeeLanding },
  { path: "/swayam-arjee-first", element: SwayamArjeeFirstPage },
  { path: "/mahabhog", element: MahaBhogFirstPage },
  { path: "/vyaktigat-arjee", element: VyaktigatArjee },
  { path: "/ekadashi-arjee", element: EkadashiArjee },
  { path: "/vyaktigat-arjee-first", element: VyaktigatArjeeFirstPage },
  // { path: "/creator-program", element: Description },
  // { path: "/creator-login", element: CreatorLogin },
  // { path: "/creator-dashboard", element: CreatorDashboard },
  // { path: "/creator-details", element: Details },
  { path: "/swayam-creator/login", element: SwayamCreatorLogin },
  { path: "/swayam-creator/dashboard", element: SwayamCreatorDashboard },
  { path: "/bheed", element: BheedRedirect },
  { path: "/bheed-bhad", element: Bheed },
  { path: "/bheed-details", element: BheedDetails },
  { path: "/param-stays", element: LandingPage },
  { path: "/param-stays-booking", element: HotelBookingPage },
  // { path: "/address", element: AddressPage, private: true },
  // { path: "/payment", element: PaymentPage, private: true },
  { path: "/dashboard", element: Dashboard, private: true },
  { path: "/all-reviews/:arjeeType", element: AllReview },
  { path: "/my-reviews/:arjeeType", element: MyReview, private: true },
  { path: "/parking-streets", element: ParkingStreets },
  { path: "/arjee-landing", element: ArjeeLanding },
  { path: "/arjee-choose", element: ArjeeChoose },
  { path: "/khatu-shyam-ji-arjee-booking", element: ArjeeLanding },
  { path: "/khatu-shyam-ji-online-arjee", element: ArjeeLanding },
  { path: "/khatu-shyam-ji-bhog", element: MahaBhogFirstPage },
  { path: "/khatu-shyam-ji-prasad", element: MahaBhogFirstPage },
  { path: "/khatu-shyam-ji-sawamani", element: MahaBhogFirstPage },
  { path: "/khatu-shyam-ji-online-bhog", element: MahaBhogFirstPage },
  { path: "/khatu-shyam-ji-arjee-kaise-lagaye", element: WhatIsOnlineSeva },
  { path: "/map-routes", element: MapRoutes },
  { path: "/map", element: MapRoutes },
  { path: "/blogs", element: BlogList },
  { path: "/blog/:slug", element: BlogPost },
  { path: "/bhog-arjee-book", element: BhogArjeePage, private: true },
  { path: "/bhog-cart", element: BhogArjeeCart },
  { path: "*", element: NotFoundFallback },
  // { path: "/lakhi-mela-updates", element: MelaUpdates },
  // { path: "/lakhi-mela-parkings", element: MelaParkings },
  // { path: "/lakhi-mela-routes", element: MelaRoutes },
];

const App = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const lastProcessedSearchRef = useRef(null);

  useEffect(() => {
    // Only apply language from URL if location.search has changed
    if (lastProcessedSearchRef.current === location.search) {
      return;
    }
    lastProcessedSearchRef.current = location.search;

    const urlLang = getLanguageFromQuery(location.search);
    if (urlLang !== null) {
      dispatch(setLanguage(urlLang));
    }
  }, [location.search, dispatch]);

  // Single root Google Analytics initialization
  useEffect(() => {
    if (
      process.env.REACT_APP_ENV === "PROD" &&
      process.env.REACT_APP_GOOGLE_ANALYTICS_GCODE_IVAR
    ) {
      ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_GCODE_IVAR);
    }
  }, []);

  // Single centralized pageview tracker for GA4, Clarity & GTM
  useEffect(() => {
    if (process.env.REACT_APP_ENV === "PROD") {
      ReactGA.send({ hitType: "pageview", page: location.pathname });

      if (window.clarity) {
        window.clarity("set", "page", location.pathname);
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "pageview",
        page: location.pathname,
      });
    }
  }, [location.pathname]);

  const isMapRoute =
    location.pathname === "/map-routes" ||
    location.pathname === "/map" ||
    location.pathname.startsWith("/map-routes") ||
    location.pathname.startsWith("/map");

  useEffect(() => {
    // Swayam Arjee Referral Interceptor
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const refCode = urlParams.get("ref");
      if (refCode) {
        // Save for 30 days
        const expiry = Date.now() + 30 * 24 * 60 * 60 * 1000;
        localStorage.setItem(
          "swayam_referral",
          JSON.stringify({ code: refCode, expiry }),
        );
      }
    } catch (error) {
      console.error("Error saving referral:", error);
    }

    // Set up foreground message listener dynamically
    import("./firebase")
      .then(({ onMessageListener }) => {
        onMessageListener((payload) => {
          // Trigger browser notification for foreground messages
          if (
            "Notification" in window &&
            Notification.permission === "granted"
          ) {
            const { title, body, image } = payload.notification || {};
            new Notification(title || "Notification", {
              body: body || "",
              icon: "/logo192.png",
              badge: "/logo192.png",
              image: image || undefined,
              tag: "pb-notification",
              requireInteraction: false,
            });
          }
        });
      })
      .catch((err) => console.log("Firebase lazy load error:", err));
  }, []);

  useEffect(() => {
    // Fix for Firebase Auth iframe missing a title (Accessibility)
    const fixIframeTitle = () => {
      const iframes = document.querySelectorAll(
        'iframe[src*="firebaseapp.com"]',
      );
      iframes.forEach((iframe) => {
        if (!iframe.getAttribute("title")) {
          iframe.setAttribute("title", "Firebase Authentication");
        }
      });
    };

    fixIframeTitle(); // Check on mount

    // Watch for dynamially added iframes
    const observer = new MutationObserver((mutations) => {
      let shouldCheck = false;
      for (const mutation of mutations) {
        if (mutation.addedNodes.length > 0) {
          shouldCheck = true;
          break;
        }
      }
      if (shouldCheck) fixIframeTitle();
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const RouteFallback = () => {
    const loc = useLocation();
    const p = loc.pathname.toLowerCase();
    const hasPaymentId = loc.search.includes("paymentId");

    // Active Arjee Pages: use the dedicated ArjeeActiveSkeleton
    if (
      p === "/ekadashi-arjee" ||
      ((p === "/vyaktigat-arjee" ||
        p === "/dainik-arjee" ||
        p === "/swayam-arjee") &&
        hasPaymentId)
    ) {
      return (
        <div className="w-full max-w-[30.5rem] mx-auto py-4">
          <ArjeeActiveSkeleton
            showUpcomingSlot={p === "/ekadashi-arjee"}
            showProof={true}
          />
        </div>
      );
    }

    if (
      p.includes("arjee") ||
      p.includes("bhog") ||
      p.includes("chadhawa") ||
      p.includes("swamani")
    ) {
      return (
        <div className="w-full max-w-[30.5rem] mx-auto py-8">
          <OfferingSkeleton count={2} />
        </div>
      );
    }
    return <GlobalLoader fullScreen={true} />;
  };

  return (
    <div
      className={`overflow-x-clip ${isMapRoute ? "h-[100dvh] overflow-hidden" : "mt-14"}`}
    >
      <InstagramRedirect />
      {!isMapRoute && <Navbar />}
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          {routesConfig.map(
            ({ path, element: Element, private: isPrivate }) => (
              <Route
                key={path}
                path={path}
                element={
                  isPrivate ? (
                    <PrivateRoute>
                      <Element />
                    </PrivateRoute>
                  ) : (
                    <Element />
                  )
                }
              />
            ),
          )}

          <Route
            path="/dainaik"
            element={<Navigate to="/dainik-arjee" replace />}
          />
          <Route
            path="/bheed"
            element={<Navigate to="/bheed-bhad" replace />}
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default App;
